import { render, staticRenderFns } from "./EntryCandidateMedicalReport.vue?vue&type=template&id=9f04267e&scoped=true&"
import script from "./EntryCandidateMedicalReport.vue?vue&type=script&lang=js&"
export * from "./EntryCandidateMedicalReport.vue?vue&type=script&lang=js&"
import style0 from "./EntryCandidateMedicalReport.vue?vue&type=style&index=0&id=9f04267e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f04267e",
  null
  
)

export default component.exports